<div class="wrapper" [formGroup]="form">
    @for (filterItem of getActiveMainFilters(); track filterItem.fieldName) {
        <div class="input-filter">
            @switch (filterItem.componentId) {
                @case (EditorType.reportingOrganization) {
                    <app-report-organization-form-editor
                        [hasLabel]="false"
                        [formControlName]="getControlName(filterItem)"
                    ></app-report-organization-form-editor>
                }
                @case (EditorType.reportingUser) {
                    <app-report-user-form-editor
                        [hasLabel]="false"
                        [placeholderText]="getPlaceholder(filterItem)"
                        [formControlName]="getControlName(filterItem)"
                    ></app-report-user-form-editor>
                }
                @case (EditorType.reportingProjectSearch) {
                    <app-report-project-search-form-editor
                        [hasLabel]="false"
                        [formControlName]="getControlName(filterItem)"
                    ></app-report-project-search-form-editor>
                }
                @case (EditorType.reportingOpportunitySearch) {
                    <app-report-opportunity-search-form-editor
                        [hasLabel]="false"
                        [formControlName]="getControlName(filterItem)"
                    ></app-report-opportunity-search-form-editor>
                }
            }
        </div>
    }
</div>
